"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

import { identify } from "@workspace/monitoring-web";

import { authClient } from "~/lib/auth/client";

const isPublicPath = (pathname: string | null) => {
  if (!pathname) return true;
  return !/^\/[^/]+\/(dashboard|admin|auth)(\/|$)/.test(pathname);
};

const AuthedMonitoringProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const session = authClient.useSession();

  useEffect(() => {
    if (session.isPending) {
      return;
    }

    identify(session.data?.user ?? null);
  }, [session]);

  return <>{children}</>;
};

export const MonitoringProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const pathname = usePathname();

  if (isPublicPath(pathname)) {
    return <>{children}</>;
  }

  return <AuthedMonitoringProvider>{children}</AuthedMonitoringProvider>;
};
